import { Link } from "react-router-dom";
import { Clock, Globe, Sparkles, CheckCircle2 } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";

const SUBJECT_COLORS = { mathematics: "#35A9F5", science: "#1FB89A", languages: "#38A85C", coding: "#3B5FD9", reading: "#F08A3C", arts: "#F06A9B", geography: "#FFB82E", culture: "#FFB82E" };

export function LessonCard({ lesson, done, i = 0 }) {
  const { t } = useI18n();
  const c = SUBJECT_COLORS[lesson.subject] || "#237BE8";
  return (
    <article data-testid={`lesson-card-${lesson.slug}`} className="card-float reveal relative flex flex-col overflow-hidden rounded-[28px] bg-white" style={{ animationDelay: `${(i % 6) * 60}ms` }}>
      <div className="h-2" style={{ background: c }} aria-hidden />
      <div className="flex flex-1 flex-col gap-3 p-6">
        <div className="flex flex-wrap items-center gap-2 text-xs font-bold">
          <span className="rounded-full px-2.5 py-1 text-white" style={{ background: c }}>{t(`subjects.${lesson.subject}`)}</span>
          <span className="rounded-full bg-[#EAF7FF] px-2.5 py-1 text-[#237BE8]">{t(`difficulty.${lesson.difficulty}`)}</span>
          <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-emerald-700">{t("common.free")}</span>
          {done && <span data-testid={`lesson-done-${lesson.slug}`} className="inline-flex items-center gap-1 rounded-full bg-[#FFD84A]/50 px-2.5 py-1 text-[#17345F]"><CheckCircle2 className="h-3.5 w-3.5" />{t("lesson.completed")}</span>}
        </div>
        <h3 className="font-heading text-xl font-extrabold leading-snug text-[#17345F]">{lesson.title}</h3>
        <p className="flex-1 text-sm leading-relaxed text-[#17345F]/70">{lesson.summary}</p>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs font-semibold text-[#17345F]/60">
          <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{lesson.duration} {t("common.minutes")}</span>
          <span className="inline-flex items-center gap-1"><Globe className="h-3.5 w-3.5" />{t(`langName.${lesson.language}`)}</span>
          <span className="inline-flex items-center gap-1"><Sparkles className="h-3.5 w-3.5" />{t(`ltype.${lesson.type}`)} · {lesson.age_range}</span>
        </div>
        <Link to={`/learn/${lesson.slug}`} data-testid={`start-lesson-${lesson.slug}`} className="btn-pill btn-primary mt-2 self-start">{t("common.startLearning")}</Link>
      </div>
    </article>
  );
}
